import { HeaderType, HeaderConfig } from '../types';

export const getHeaderTypeFromPath = (pathSegment: string): HeaderType => {
  switch (pathSegment) {
    case '':
    case 'communities':
      return 'communities';
    case 'community':
      return 'community';
    case 'member':
      return 'member';
    case 'member-energy':
    case 'member-economics':
      return 'member-data-vis';
    case 'site':
      return 'site-overview';
    case 'site-energy':
    case 'site-economics':
      return 'site';
    case 'community-energy':
    case 'community-economics':
      return 'community-data-vis';
    default:
      return 'default';
  }
};

export const getHeaderConfig = (pathSegment: string, props: any): HeaderConfig => {
  const type = getHeaderTypeFromPath(pathSegment);
  const {
    navigation = null,
    calendar = null,
    download = null,
    searchBar = null,
    profile = null,
    breadCrumbs = null,
  } = props;

  const baseConfig = {
    type,
    showCalendar: Boolean(calendar),
    showSearch: Boolean(searchBar),
    showProfile: Boolean(profile),
    showDownload: Boolean(download),
  };

  // Return configuration based on type
  return baseConfig;
}; 